import React from "react";
import { Select } from "@mui/material";
import {
  BACKGROUND_COLORS,
  BORDER_COLORS,
  BRAND_COLORS,
  TEXT_COLORS,
} from "../../../style/colors";

const AppSelect = ({ sx, children, ...props }) => {
  return (
    <Select
      variant='outlined'
      size='small'
      sx={{
        minHeight: 40,
        borderRadius: 2.5,
        backgroundColor: BACKGROUND_COLORS.CARD,
        color: TEXT_COLORS.PRIMARY,
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: BORDER_COLORS.SECONDARY,
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: BORDER_COLORS.BRAND,
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: BRAND_COLORS.ACCENT,
          borderWidth: 2,
        },
        ...sx,
      }}
      {...props}>
      {children}
    </Select>
  );
};

export default AppSelect;
